import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Collapse, Text, TextFeature, TextSize } from '@as/cotopaxi';
import { HtmlInclude } from '../../common/html-include/HtmlInclude';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { Divider } from '@yonderland/andes-react';
export const MiniPDPDescription = ({ description }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    return (_jsxs(_Fragment, { children: [_jsx(Divider, {}), _jsx(Collapse, { id: "mini-pdp-description", title: t('pdp.mini.description'), hasDivider: false, children: _jsx(Text, { feature: TextFeature.PRODUCT_TECHNICAL_DESCRIPTION, size: TextSize.SMALL, dataQA: "product_description", withGlossary: true, children: _jsx(HtmlInclude, { htmlFragment: description }) }) })] }));
};
